import { render, staticRenderFns } from "./11.vue?vue&type=template&id=35e0c280&scoped=true&"
import script from "./11.vue?vue&type=script&lang=js&"
export * from "./11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0c280",
  null
  
)

export default component.exports